/* eslint-disable no-undef */
<template>
  <v-navigation-drawer
    v-model="drawer"
    right
    temporary
    fixed
    width="600"
    class="sheet-salesforce"
  >
    <v-card
      :loading="loading"
      flat
      height="100%"
      class="d-flex flex-column sheet-salesforce__card"
    >
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="headline">Detalle Salesforce</span>
        <v-btn icon @click="cerrarSheet">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="text--primary px-6 sheet-salesforce__content">
        <v-row>
          <v-col cols="12" sm="6">
            <p>
              <strong>Caso:</strong>
              <span>{{ datos.caso || "-" }}</span>
            </p>
            <p>
              <strong>Caso Salesforce:</strong>
              <span>{{ datos.caso_salesforce || "-" }}</span>
            </p>
            <p>
              <strong>Fecha / hora evento:</strong>
              <span>{{ datos.fecha_hora_evento || "-" }}</span>
            </p>
            <p>
              <strong>Placa:</strong>
              <span>{{ datos.placa || "-" }}</span>
            </p>
            <p>
              <strong>Tipo póliza:</strong>
              <span>{{ datos.tipo_poliza || "-" }}</span>
            </p>
            <p>
              <strong>Inicio vigencia:</strong>
              <span>{{ datos.inicio_vigencia || "-" }}</span>
            </p>
            <p>
              <strong>Fin vigencia:</strong>
              <span>{{ datos.fin_vigencia || "-" }}</span>
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <p>
              <strong>Tipo usuario:</strong>
              <span>{{ datos.tipo_usuario || "-" }}</span>
            </p>
            <p>
              <strong>Nombre usuario:</strong>
              <span>{{ datos.nombre_usuario || "-" }}</span>
            </p>
            <p>
              <strong>Teléfono 1:</strong>
              <span>{{ datos.telefono_usuario_1 || "-" }}</span>
            </p>
            <p>
              <strong>Teléfono 2:</strong>
              <span>{{ datos.telefono_usuario_2 || "-" }}</span>
            </p>
            <p>
              <strong>Teléfono 3:</strong>
              <span>{{ datos.telefono_usuario_3 || "-" }}</span>
            </p>
            <p>
              <strong>Correo:</strong>
              <span>{{ datos.correo_usuario || "-" }}</span>
            </p>
            <p>
              <strong>Tipo / número documento:</strong>
              <span>
                {{ datos.tipo_documento_usuario || "-" }}
                {{ datos.numero_documento_usuario || "" }}
              </span>
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <p>
              <strong>Tipo evento:</strong>
              <span>{{ datos.tipo_evento || "-" }}</span>
            </p>
            <p v-if="datos.otro_tipo_evento">
              <strong>Otro tipo evento:</strong>
              <span>{{ datos.otro_tipo_evento }}</span>
            </p>
            <p>
              <strong>Objeto evento:</strong>
              <span>{{ datos.objeto_evento || "-" }}</span>
            </p>
            <p>
              <strong>Departamento evento:</strong>
              <span>{{
                datos.departamento_evento || datos.departamento || "-"
              }}</span>
            </p>
            <p>
              <strong>Ciudad evento:</strong>
              <span>{{
                datos.ciudad_evento || datos.ciudad_siniestro || "-"
              }}</span>
            </p>
          </v-col>

          <v-col cols="12" sm="6">
            <p>
              <strong>Dirección evento:</strong>
              <span>{{
                datos.direccion_evento || datos.direccion_siniestro || "-"
              }}</span>
            </p>
            <p>
              <strong>Punto de referencia:</strong>
              <span>{{ datos.punto_referencia || "-" }}</span>
            </p>
            <p>
              <strong>Sentido vial:</strong>
              <span>{{ datos.sentido_vial || "-" }}</span>
            </p>
            <p>
              <strong>Observaciones:</strong>
              <span>{{ datos.observaciones || "-" }}</span>
            </p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="sheet-salesforce__footer pb-4 px-6">
        <slot name="footer-left"></slot>
        <v-spacer></v-spacer>
        <slot name="footer-right">
          <v-btn color="success" dark @click="copiarDatos"> Copiar </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { db } from "../../firebase";

export default {
  name: "SheetSalesForce",
  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  data: () => ({
    loading: false,
    drawer: false,
    datos: {},
  }),
  watch: {
    showModal(newVal) {
      this.drawer = newVal;
      if (newVal && this.id) {
        this.cargarDatos();
      }
    },
  },
  async mounted() {
    this.drawer = this.showModal;
    if (this.showModal && this.id) {
      await this.cargarDatos();
    }
  },
  methods: {
    async cargarDatos() {
      try {
        this.loading = true;
        const doc = await db.collection("casos").doc(this.id).get();
        if (doc.exists) {
          this.datos = doc.data() || {};
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        const message = error && error.message ? error.message : String(error);
        this.$swal({ icon: "error", title: "Oops...", text: message });
      }
    },
    cerrarSheet() {
      this.drawer = false;
      this.$emit("update:showModal", false);
    },
    async copiarDatos() {
      const d = this.datos || {};

      const telefono =
        d.telefono_usuario_1 ||
        d.telefono_usuario_2 ||
        d.telefono_usuario_3 ||
        "";

      const vigencia =
        d.inicio_vigencia && d.fin_vigencia
          ? `${d.inicio_vigencia} - ${d.fin_vigencia}`
          : d.inicio_vigencia || d.fin_vigencia || "";

      const texto = [
        `Placa: ${d.placa || ""}`,
        `Tipo de póliza: ${d.tipo_poliza || ""}`,
        `Vigencia: ${vigencia}`,
        `Nombre del usuario: ${d.nombre_usuario || ""}`,
        `Teléfono del usuario: ${telefono}`,
        `Correo electrónico: ${d.correo_usuario || ""}`,
        `Cédula: ${d.numero_documento_usuario || ""}`,
        `Tipo de evento: ${d.tipo_evento || ""}`,
        `Contra qué se produjo el choque: ${d.objeto_evento || ""}`,
        `Ciudad del evento: ${d.ciudad_evento || d.ciudad_siniestro || ""}`,
        `Departamento del evento: ${
          d.departamento_evento || d.departamento || ""
        }`,
        `Dirección del evento: ${
          d.direccion_evento || d.direccion_siniestro || ""
        }`,
        `Punto de referencia: ${d.punto_referencia || ""}`,
        `Sentido vial: ${d.sentido_vial || ""}`,
        `Observaciones: ${d.observaciones || ""}`,
      ].join("\n");

      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = texto;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$swal({
          toast: true,
          position: "top",
          icon: "success",
          title: "Copiado",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.style.width = "220px";
            const titleEl = toast.querySelector(".swal2-title");
            if (titleEl) {
              titleEl.style.fontSize = "20px";
              titleEl.style.fontWeight = "800";
            }
          },
        });
      } catch (error) {
        const message = error && error.message ? error.message : String(error);
        this.$swal({
          icon: "error",
          title: "No se pudo copiar",
          text: message,
        });
      }
    },
  },
};
</script>

<style scoped>
.sheet-salesforce {
  z-index: 1000;
}

.sheet-salesforce >>> .v-navigation-drawer__content {
  overflow: hidden;
}

.sheet-salesforce__card {
  display: flex;
  flex-direction: column;
}

.sheet-salesforce__content {
  flex: 1 1 auto;
  overflow-y: auto;
  font-size: 13px;
  padding-top: 8px;
}

.sheet-salesforce__footer {
  flex-shrink: 0;
}

.sheet-salesforce__content p {
  margin: 0;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e2e8f0;
}

.sheet-salesforce__content p strong {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.sheet-salesforce__content p span {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}
</style>
